import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import FilterText from "../FilterText";
import { IFilter } from "../../../../types/filter.type";
import FilterTimeFormTo from "../FilterTimeFormTo";

function FilterCRHC({ filter, setFilter, load }: IFilter) {
  const defaultFilter = {
    ten_hc: "",
    dvt: "",
    soluong: "",
    xuatxu: "",
    nhanhieu: "",
    kyhieu: "",
    hsx: "",
    mahs: "",
    model: "",
    soluuhanh: "",
    cauhinhkythuat: "",
    tbmt: "",
    cdt: "",
    sqd: "",
    diadiem: "",
    ngayqdFrom: null,
    ngayqdTo: null,
  };

  useEffect(() => {
    setFilter(defaultFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load]);

  return (
    <Stack sx={{ width: "100%" }} gap={2}>
      <FilterTimeFormTo
        label="Ngày quyết định"
        timeFrom={filter.ngayqdFrom}
        timeTo={filter.ngayqdTo}
        onChange={({ timeFrom, timeTo }) => {
          setFilter({ ngayqdFrom: timeFrom, ngayqdTo: timeTo });
        }}
      />
      <FilterText
        direction="column"
        label="Tên hóa chất"
        placeholder="Tìm theo tên hóa chất"
        defaultValue={filter.ten_hc}
        onChange={(val) => setFilter({ ...filter, ten_hc: val })}
      />
      <FilterText
        direction="column"
        label="Hãng sản xuất"
        placeholder="Tìm theo hãng sản xuất"
        defaultValue={filter.hsx}
        onChange={(val) => setFilter({ ...filter, hsx: val })}
      />
      <FilterText
        direction="column"
        label="Nhãn hiệu"
        placeholder="Tìm theo nhãn hiệu"
        defaultValue={filter.nhanhieu}
        onChange={(val) => setFilter({ ...filter, nhanhieu: val })}
      />
      <FilterText
        direction="column"
        label="Đơn vị tính"
        placeholder="Tìm theo đơn vị tính"
        defaultValue={filter.dvt}
        onChange={(val) => setFilter({ ...filter, dvt: val })}
      />
      <FilterText
        direction="column"
        label="Xuất xứ"
        placeholder="Tìm theo xuất xứ"
        defaultValue={filter.xuatxu}
        onChange={(val) => setFilter({ ...filter, xuatxu: val })}
      />
      <FilterText
        direction="column"
        label="Ký hiệu"
        placeholder="Tìm theo ký hiệu"
        defaultValue={filter.kyhieu}
        onChange={(val) => setFilter({ ...filter, kyhieu: val })}
      />
      <FilterText
        direction="column"
        label="Mã hồ sơ"
        placeholder="Tìm theo mã hồ sơ"
        defaultValue={filter.mahs}
        onChange={(val) => setFilter({ ...filter, mahs: val })}
      />
      <FilterText
        direction="column"
        label="Chủng loại"
        placeholder="Tìm theo chủng loại"
        defaultValue={filter.model}
        onChange={(val) => setFilter({ ...filter, model: val })}
      />
      <FilterText
        direction="column"
        label="Số lưu hành"
        placeholder="Tìm theo số lưu hành"
        defaultValue={filter.soluuhanh}
        onChange={(val) => setFilter({ ...filter, soluuhanh: val })}
      />
      <FilterText
        direction="column"
        label="Cấu hình"
        placeholder="Tìm theo cấu hình"
        defaultValue={filter.cauhinhkythuat}
        onChange={(val) => setFilter({ ...filter, cauhinhkythuat: val })}
      />
      <FilterText
        direction="column"
        label="Mã TBMT"
        placeholder="Tìm theo mã TBMT"
        defaultValue={filter.tbmt}
        onChange={(val) => setFilter({ ...filter, tbmt: val })}
      />
      <FilterText
        direction="column"
        label="Tên CĐT"
        placeholder="Tìm theo tên CĐT"
        defaultValue={filter.cdt}
        onChange={(val) => setFilter({ ...filter, cdt: val })}
      />
      <FilterText
        direction="column"
        label="Số QĐ"
        placeholder="Tìm theo số QĐ"
        defaultValue={filter.sqd}
        onChange={(val) => setFilter({ ...filter, sqd: val })}
      />
      <FilterText
        direction="column"
        label="Địa điểm"
        placeholder="Tìm theo địa điểm"
        defaultValue={filter.diadiem}
        onChange={(val) => setFilter({ ...filter, diadiem: val })}
      />
    </Stack>
  );
}

export default FilterCRHC;
